var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadPdfOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 2,
    fill: "#183433"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17918_52895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 9V11H9V24H23V11H20V9H23C24.1046 9 25 9.89543 25 11V24C25 25.1046 24.1046 26 23 26H9C7.89543 26 7 25.1046 7 24V11C7 9.89543 7.89543 9 9 9H12ZM16 6C16.5523 6 17 6.44772 17 7V17.8284L18.8284 16C19.219 15.6094 19.8521 15.6094 20.2426 16C20.6332 16.3905 20.6332 17.0237 20.2426 17.4142L16.8839 20.7729C16.3957 21.2611 15.6043 21.2611 15.1161 20.7729L11.7574 17.4142C11.3668 17.0237 11.3668 16.3905 11.7574 16C12.1479 15.6094 12.781 15.6094 13.1716 16L15 17.8284V7C15 6.44772 15.4477 6 16 6Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17918_52895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPdfOn);
export default __webpack_public_path__ + "static/media/downloadPdfOn.41d112cd483bd1b88bc3e603bc8a9bd4.svg";
export { ForwardRef as ReactComponent };